// Mock data for Financial Transactions
// This file contains structured data for financial transactions linked to other modules
// Following systematic naming conventions for future Supabase migration

export const financialTransactionsData = {
  // Transactions linked to sales orders
  salesOrderTransactions: [
    {
      transaction_id: "fin-trans-so-001",
      reference_type: "sales_order",
      reference_id: "SO-20250615-001",
      transaction_date: "2025-06-20T10:15:00",
      amount: 125000.00,
      currency: "HKD",
      transaction_type: "accounts_receivable",
      status: "completed",
      payment_method: "bank_transfer",
      account_id: "cash-001",
      customer_id: "cust-001",
      description: "收到銷售訂單 SO-20250615-001 付款",
      created_by: "user-001",
      created_at: "2025-06-20T10:15:00"
    },
    {
      transaction_id: "fin-trans-so-002",
      reference_type: "sales_order",
      reference_id: "SO-20250620-003",
      transaction_date: "2025-06-25T14:30:00",
      amount: 89500.00,
      currency: "HKD",
      transaction_type: "accounts_receivable",
      status: "completed",
      payment_method: "credit_card",
      account_id: "cash-001",
      customer_id: "cust-003",
      description: "收到銷售訂單 SO-20250620-003 付款",
      created_by: "user-002",
      created_at: "2025-06-25T14:30:00"
    },
    {
      transaction_id: "fin-trans-so-003",
      reference_type: "sales_order",
      reference_id: "SO-20250622-005",
      transaction_date: "2025-06-28T09:45:00",
      amount: 215000.00,
      currency: "HKD",
      transaction_type: "accounts_receivable",
      status: "pending",
      payment_method: "bank_transfer",
      account_id: "cash-001",
      customer_id: "cust-005",
      description: "銷售訂單 SO-20250622-005 應收款項",
      created_by: "user-001",
      created_at: "2025-06-28T09:45:00"
    }
  ],
  
  // Transactions linked to purchase orders
  purchaseOrderTransactions: [
    {
      transaction_id: "fin-trans-po-001",
      reference_type: "purchase_order",
      reference_id: "PO-20250610-002",
      transaction_date: "2025-06-18T11:20:00",
      amount: -78500.00,
      currency: "HKD",
      transaction_type: "accounts_payable",
      status: "completed",
      payment_method: "bank_transfer",
      account_id: "cash-001",
      supplier_id: "sup-002",
      description: "支付採購訂單 PO-20250610-002 款項",
      created_by: "user-003",
      created_at: "2025-06-18T11:20:00"
    },
    {
      transaction_id: "fin-trans-po-002",
      reference_type: "purchase_order",
      reference_id: "PO-20250615-004",
      transaction_date: "2025-06-22T16:40:00",
      amount: -156000.00,
      currency: "HKD",
      transaction_type: "accounts_payable",
      status: "completed",
      payment_method: "bank_transfer",
      account_id: "cash-001",
      supplier_id: "sup-004",
      description: "支付採購訂單 PO-20250615-004 款項",
      created_by: "user-003",
      created_at: "2025-06-22T16:40:00"
    },
    {
      transaction_id: "fin-trans-po-003",
      reference_type: "purchase_order",
      reference_id: "PO-20250620-006",
      transaction_date: "2025-07-05T10:30:00",
      amount: -92000.00,
      currency: "HKD",
      transaction_type: "accounts_payable",
      status: "pending",
      payment_method: "bank_transfer",
      account_id: "cash-001",
      supplier_id: "sup-001",
      description: "採購訂單 PO-20250620-006 應付款項",
      created_by: "user-003",
      created_at: "2025-07-05T10:30:00"
    }
  ],
  
  // Transactions linked to payroll
  payrollTransactions: [
    {
      transaction_id: "fin-trans-pay-001",
      reference_type: "payroll",
      reference_id: "PAY-202506",
      transaction_date: "2025-06-30T16:00:00",
      amount: -3850000.00,
      currency: "HKD",
      transaction_type: "payroll_expense",
      status: "completed",
      payment_method: "bank_transfer",
      account_id: "cash-001",
      description: "六月份薪資支出",
      created_by: "user-004",
      created_at: "2025-06-30T16:00:00"
    }
  ],
  
  // Transactions linked to tax payments
  taxTransactions: [
    {
      transaction_id: "fin-trans-tax-001",
      reference_type: "tax_payment",
      reference_id: "TAX-2025Q2",
      transaction_date: "2025-06-15T14:00:00",
      amount: -950000.00,
      currency: "HKD",
      transaction_type: "tax_expense",
      status: "completed",
      payment_method: "bank_transfer",
      account_id: "cash-001",
      description: "2025年第二季度稅款支付",
      created_by: "user-004",
      created_at: "2025-06-15T14:00:00"
    }
  ],
  
  // Transactions linked to inventory
  inventoryTransactions: [
    {
      transaction_id: "fin-trans-inv-001",
      reference_type: "inventory_adjustment",
      reference_id: "INV-ADJ-20250625-001",
      transaction_date: "2025-06-25T15:30:00",
      amount: -25000.00,
      currency: "HKD",
      transaction_type: "inventory_write_off",
      status: "completed",
      account_id: "cash-001",
      description: "庫存調整：過期產品報廢",
      created_by: "user-005",
      created_at: "2025-06-25T15:30:00"
    }
  ],
  
  // Investment transactions
  investmentTransactions: [
    {
      transaction_id: "fin-trans-inv-001",
      reference_type: "investment",
      reference_id: "INV-20250601-001",
      transaction_date: "2025-06-01T09:00:00",
      amount: -2000000.00,
      currency: "HKD",
      transaction_type: "investment_outflow",
      status: "completed",
      payment_method: "bank_transfer",
      account_id: "cash-002",
      description: "設備更新投資",
      created_by: "user-001",
      created_at: "2025-06-01T09:00:00"
    },
    {
      transaction_id: "fin-trans-inv-002",
      reference_type: "investment",
      reference_id: "INV-20250610-002",
      transaction_date: "2025-06-10T11:00:00",
      amount: 350000.00,
      currency: "HKD",
      transaction_type: "investment_income",
      status: "completed",
      payment_method: "bank_transfer",
      account_id: "cash-003",
      description: "投資收益",
      created_by: "user-001",
      created_at: "2025-06-10T11:00:00"
    }
  ],
  
  // Loan transactions
  loanTransactions: [
    {
      transaction_id: "fin-trans-loan-001",
      reference_type: "loan_payment",
      reference_id: "LOAN-20250101-001",
      transaction_date: "2025-06-15T14:30:00",
      amount: -1250000.00,
      currency: "HKD",
      transaction_type: "loan_repayment",
      status: "completed",
      payment_method: "bank_transfer",
      account_id: "cash-001",
      description: "銀行貸款月度還款",
      created_by: "user-004",
      created_at: "2025-06-15T14:30:00"
    }
  ],
  
  // Bank reconciliation data
  bankReconciliations: [
    {
      reconciliation_id: "recon-202506-001",
      account_id: "cash-001",
      period: "2025-06",
      start_date: "2025-06-01",
      end_date: "2025-06-30",
      starting_balance: 14500000.00,
      ending_balance: 15250000.00,
      bank_statement_balance: 15250000.00,
      reconciliation_status: "completed",
      reconciliation_date: "2025-07-03T10:00:00",
      reconciled_by: "user-004",
      notes: "六月份銀行對帳單已核對完成，無差異"
    },
    {
      reconciliation_id: "recon-202506-002",
      account_id: "cash-002",
      period: "2025-06",
      start_date: "2025-06-01",
      end_date: "2025-06-30",
      starting_balance: 5500000.00,
      ending_balance: 3500000.00,
      bank_statement_balance: 3500000.00,
      reconciliation_status: "completed",
      reconciliation_date: "2025-07-03T11:30:00",
      reconciled_by: "user-004",
      notes: "六月份銀行對帳單已核對完成，無差異"
    },
    {
      reconciliation_id: "recon-202506-003",
      account_id: "cash-003",
      period: "2025-06",
      start_date: "2025-06-01",
      end_date: "2025-06-30",
      starting_balance: 450000.00,
      ending_balance: 500000.00,
      bank_statement_balance: 500000.00,
      reconciliation_status: "completed",
      reconciliation_date: "2025-07-03T14:00:00",
      reconciled_by: "user-004",
      notes: "六月份銀行對帳單已核對完成，無差異"
    }
  ]
};

// Financial reports data
export const financialReportsData = {
  // Income Statement
  incomeStatement: {
    report_id: "fin-report-is-202506",
    period: "2025-06",
    report_date: "2025-07-05",
    revenue: {
      sales_revenue: 8500000.00,
      service_revenue: 1200000.00,
      other_revenue: 350000.00,
      total_revenue: 10050000.00
    },
    cost_of_goods_sold: {
      raw_materials: 3500000.00,
      direct_labor: 1800000.00,
      manufacturing_overhead: 950000.00,
      total_cogs: 6250000.00
    },
    gross_profit: 3800000.00,
    operating_expenses: {
      sales_marketing: 750000.00,
      general_admin: 950000.00,
      research_development: 650000.00,
      total_operating_expenses: 2350000.00
    },
    operating_income: 1450000.00,
    other_income_expenses: {
      interest_income: 50000.00,
      interest_expense: -180000.00,
      other_income: 30000.00,
      total_other_income_expenses: -100000.00
    },
    income_before_tax: 1350000.00,
    income_tax: 270000.00,
    net_income: 1080000.00
  },
  
  // Balance Sheet
  balanceSheet: {
    report_id: "fin-report-bs-202506",
    period: "2025-06-30",
    report_date: "2025-07-05",
    assets: {
      current_assets: {
        cash_equivalents: 15250000.00,
        accounts_receivable: 4500000.00,
        inventory: 7800000.00,
        prepaid_expenses: 450000.00,
        total_current_assets: 28000000.00
      },
      non_current_assets: {
        property_plant_equipment: 35000000.00,
        accumulated_depreciation: -12000000.00,
        intangible_assets: 5500000.00,
        long_term_investments: 8500000.00,
        total_non_current_assets: 37000000.00
      },
      total_assets: 65000000.00
    },
    liabilities: {
      current_liabilities: {
        accounts_payable: 3800000.00,
        short_term_loans: 2500000.00,
        current_tax_liabilities: 950000.00,
        accrued_expenses: 1200000.00,
        total_current_liabilities: 8450000.00
      },
      non_current_liabilities: {
        long_term_loans: 12500000.00,
        deferred_tax_liabilities: 1800000.00,
        total_non_current_liabilities: 14300000.00
      },
      total_liabilities: 22750000.00
    },
    equity: {
      share_capital: 25000000.00,
      retained_earnings: 16250000.00,
      current_year_earnings: 1000000.00,
      total_equity: 42250000.00
    },
    total_liabilities_equity: 65000000.00
  },
  
  // Cash Flow Statement
  cashFlowStatement: {
    report_id: "fin-report-cf-202506",
    period: "2025-06",
    report_date: "2025-07-05",
    operating_activities: {
      net_income: 1080000.00,
      adjustments: {
        depreciation_amortization: 450000.00,
        changes_in_receivables: -350000.00,
        changes_in_inventory: -250000.00,
        changes_in_payables: 180000.00,
        changes_in_other_operating: 120000.00,
        total_adjustments: 150000.00
      },
      net_cash_from_operating: 1230000.00
    },
    investing_activities: {
      capital_expenditures: -2000000.00,
      proceeds_from_investments: 350000.00,
      net_cash_from_investing: -1650000.00
    },
    financing_activities: {
      loan_repayments: -1250000.00,
      dividends_paid: -500000.00,
      net_cash_from_financing: -1750000.00
    },
    net_change_in_cash: -2170000.00,
    beginning_cash_balance: 17420000.00,
    ending_cash_balance: 15250000.00
  }
};
